module.exports = __webpack_public_path__ + "media/images/brand-assets/light_2-cf82b996a3fe5e79a042db5576ce42ae.png";